var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconKeyboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:#3c3f45;}.a{opacity:0;}.c{fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.5,17.5A.5.5,0,1,1,8,18,.5.5,0,0,1,7.5,17.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11,17a.5.5,0,1,0,.5.5A.5.5,0,0,0,11,17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.5,17.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,13.5,17.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17,17a.5.5,0,1,0,.5.5A.5.5,0,0,0,17,17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.5,17.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,19.5,17.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23,17a.5.5,0,1,0,.5.5A.5.5,0,0,0,23,17Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.5,17.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,25.5,17.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29,17a.5.5,0,1,0,.5.5A.5.5,0,0,0,29,17Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.5,17.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,31.5,17.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8,20a.5.5,0,1,0,.5.5A.5.5,0,0,0,8,20Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.5,20.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,10.5,20.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14,20a.5.5,0,1,0,.5.5A.5.5,0,0,0,14,20Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.5,20.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,16.5,20.5Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20,20a.5.5,0,1,0,.5.5A.5.5,0,0,0,20,20Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.5,20.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,22.5,20.5Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M26,20a.5.5,0,1,0,.5.5A.5.5,0,0,0,26,20Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.5,20.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,28.5,20.5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32,20a.5.5,0,1,0,.5.5A.5.5,0,0,0,32,20Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.5,23.5A.5.5,0,1,1,8,24,.5.5,0,0,1,7.5,23.5Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11,23a.5.5,0,1,0,.5.5A.5.5,0,0,0,11,23Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.5,23.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,13.5,23.5Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17,23a.5.5,0,1,0,.5.5A.5.5,0,0,0,17,23Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.5,23.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,19.5,23.5Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23,23a.5.5,0,1,0,.5.5A.5.5,0,0,0,23,23Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.5,23.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,25.5,23.5Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29,23a.5.5,0,1,0,.5.5A.5.5,0,0,0,29,23Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.5,23.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,31.5,23.5Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8,26a.5.5,0,1,0,.5.5A.5.5,0,0,0,8,26Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.5,26.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,10.5,26.5Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14,26a.5.5,0,0,0,0,1H26a.5.5,0,0,0,0-1Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.5,26.5a.5.5,0,1,1,.5.5A.5.5,0,0,1,28.5,26.5Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32,26a.5.5,0,1,0,.5.5A.5.5,0,0,0,32,26Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.5,14A2.5,2.5,0,0,1,6,11.5H34A2.5,2.5,0,0,1,36.5,14V27A2.5,2.5,0,0,1,34,29.5H6A2.5,2.5,0,0,1,3.5,27ZM6,12.5A1.5,1.5,0,0,0,4.5,14v1h31V14A1.5,1.5,0,0,0,34,12.5H32.5v1a.5.5,0,0,1-1,0v-1h-1v1a.5.5,0,0,1-1,0v-1h-1v1a.5.5,0,0,1-1,0v-1ZM4.5,27V16h31V27A1.5,1.5,0,0,1,34,28.5H6A1.5,1.5,0,0,1,4.5,27Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyboard);
export default __webpack_public_path__ + "static/media/icon-keyboard.5c34d021.svg";
export { ForwardRef as ReactComponent };